import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import PermissionHOC from "../PermissionHOC";
import connect from "react-redux/es/connect/connect";
import { Image, Form } from "react-bootstrap";
import AddDocument from "../../assets/add-documents.svg";
import DatePickerField from "../../component/InputFieldLayout/datePicker";
import TimePickerField from "../../component/InputFieldLayout/timePickerField";
import RadioButtonLayout from "../../component/InputFieldLayout/radioButtonLayout";
import OptionsField from "../../component/InputFieldLayout/SelectOptionsField";
import TextAreaField from "../../component/InputFieldLayout/textAreaField";
import TextField from "../../component/InputFieldLayout/textField";
import { FILE_FORMATS, ERROR_MSG } from "../../constant";
import { toast } from "react-toastify";
import { removeFileAction } from "../../actions/common.action";
import { loadPageInfo } from "../../actions/mom.action";
import { getMeetingTypesDetails } from "../../actions/projectDetail.action";
import { createProjectDecisionAction } from "../../actions/createProject.action";
import { getProjectDecisionDetailsAction } from "../../actions/projectDetail.action";
import { UploadAttachmentsWithTitleComponent } from "../reusableComponent";
import { DisplayAttachments } from "../reusableComponent";
import { LoaderPage } from "../../component/Loader";
import { successToastStyle, errorToastStyle } from "../../customToast";
import htmlToFormattedText from "html-to-formatted-text";
export class AddDecisionSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingDate: new Date(),
      meetingTimeFrom: "",
      meetingTimeTo: "",
      decisionName: "",
      meetingChairedBy: "",
      meetingMode: "VIDEO_CONFERENCE",
      projectMOM: "",
      projectMeetingType: "",
      attachmentPayload: [],
      responseFromUploadApi: {},
      attachedFileId: [],
      projectMeetingTypeDetails: [],
      meetingVenue: "",
      showRequiredError: false,
      toggleAttachmentDisplay: false,
      canUploadVideo: false,
      keyNameForOption: ""
    };
  }
  componentDidMount() {
    const { loadPageInfo, getMeetingTypesDetails } = this.props;
    loadPageInfo();
    getMeetingTypesDetails().then(resp => {
      if (resp) {
        this.setState({ projectMeetingTypeDetails: resp });
      }
    });
  }
  onMeetingInformationChange = (event, name) => {
    if (name === "meeting-name") {
      this.setState({ decisionName: event });
    } else {
      this.setState({ meetingChairedBy: event });
    }
  };

  onMeetingDescriptionChange = event => {
    this.setState({ projectMOM: event.target.value });
  };

  onMeetingDateChange = value => {
    this.setState({ meetingDate: new Date(value) });
  };
  onMeetingTimeChange = (value, name) => {
    if (name === "meeting-start-time") {
      this.setState({ meetingTimeFrom: value });
    } else {
      this.setState({
        meetingTimeTo: value
      });
    }
  };
  onSelectedField = (event, name) => {
    if (name === "meeting-venue") {
      this.setState({ keyNameForOption: name });
    } else {
      this.setState({ keyNameForOption: name });
    }
  };
  onDecisionDropdownSelect = (event, name) => {
    if (name === "meeting-venue") {
      this.setState({
        meetingVenue: event
      });
    } else {
      this.setState({
        projectMeetingType: event,
        keyNameForOption: name
      });
    }
  };

  onMeetingModeChange = value => {
    this.setState({
      meetingMode: value.target.name
    });
  };

  onToggleAttachment = index => {
    this.setState({
      toggleAttachmentDisplay: !this.state.toggleAttachmentDisplay
    });
  };

  onSuccessUploadOfAttachments = async data => {
    try {
      this.setState({
        attachmentPayload: [...this.state.attachmentPayload, data]
      });
    } catch (error) {
      console.error(error.message);
    }
  };

  onRemoveFile = ({ id }) => {
    try {
      this.setState({
        attachmentPayload: this.state.attachmentPayload.filter(
          val => val.id !== id
        )
      });
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };
  validateForm = () => {
    const {
      projectMOM,
      meetingVenue,
      meetingChairedBy,
      decisionName,
      projectMeetingType,
      meetingTimeFrom
    } = this.state;
    if (
      projectMOM === "" ||
      meetingVenue === "" ||
      meetingChairedBy === "" ||
      decisionName === "" ||
      projectMeetingType === "" ||
      meetingTimeFrom === ""
    ) {
      this.setState({ showRequiredError: true });
      toast.error(
        <p className="toast-text-alignment">Mandatory Fields Are Missing</p>,
        errorToastStyle
      );
    }
  };
  onAddingDecision = async () => {
    const {
      createProjectDecisionDispatch,
      projectData,
      showAddedDecisionList,
      getProjectDecisionDetailsDispatch
    } = this.props;
    const {
      projectMOM,
      meetingVenue,
      meetingChairedBy,
      decisionName,
      projectMeetingType,
      meetingTimeFrom
    } = this.state;
    if (
      projectMOM === "" ||
      meetingVenue === "" ||
      meetingChairedBy === "" ||
      decisionName === "" ||
      projectMeetingType === "" ||
      meetingTimeFrom === ""
    ) {
      this.validateForm();
      return;
    }
    // let meetingDecisionType = projectMeetingType.replace(/ /g, "_");
    let meetingDecisionType = (projectMeetingType.value || "").replace(
      / /g,
      "_"
    );
    var stateOfAddDecision = {
      decisionName: htmlToFormattedText(this.state.decisionName),
      meetingDate: new Date(this.state.meetingDate).getTime(),
      meetingTimeFrom: new Date(this.state.meetingTimeFrom).getTime(),
      meetingTimeTo: new Date(this.state.meetingTimeTo).getTime(),
      venue: parseInt(this.state.meetingVenue),
      meetingChairedBy: htmlToFormattedText(this.state.meetingChairedBy),
      projectMOM: htmlToFormattedText(this.state.projectMOM),
      projectMeetingType: meetingDecisionType,
      meetingMode: htmlToFormattedText(this.state.meetingMode),
      fileAttachment:
        this.state.attachmentPayload.length === 0
          ? []
          : [this.state.attachmentPayload[0].id],
      projectId: projectData.id
    };
    try {
      const response = await createProjectDecisionDispatch(
        undefined,
        stateOfAddDecision
      );
      if (response) {
        const { status, message } = response;
        if (status === 200) {
          toast.success(
            <p className="toast-text-alignment">
              Meeting Decision Added Successfully
            </p>,
            successToastStyle
          );
          this.setState({
            meetingDate: new Date(),
            meetingTimeFrom: "",
            meetingTimeTo: "",
            decisionName: "",
            meetingChairedBy: "",
            meetingMode: "VIDEO_CONFERENCE",
            projectMOM: "",
            projectMeetingType: "",
            attachmentPayload: [],
            responseFromUploadApi: {},
            attachedFileId: [],
            projectMeetingTypeDetails: [],
            meetingVenue: "",
            showRequiredError: false
          });
          this.props.showAddedDecisionList(true);
          getProjectDecisionDetailsDispatch(undefined, {
            id: projectData.id
          }).then(response => {
            this.setState({ projectAddedDecisionData: response.data });
          });
        }
      } else {
        toast.error(
          <p className="toast-text-alignment">
            {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
          </p>,
          errorToastStyle
        );
      }
    } catch (e) {
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  render() {
    const {
      meetingDate,
      meetingMode,
      meetingChairedBy,
      meetingTimeTo,
      decisionName,
      meetingTimeFrom,
      meetingVenue,
      projectMOM,
      keyNameForOption,
      projectMeetingType,
      showRequiredError,
      toggleAttachmentDisplay,
      canUploadVideo
    } = this.state;
    const {
      pageInfo,
      projectAddDecisionStatus,
      projectAddDecisionMeetingTypes
    } = this.props;
    return (
      <div className="add-decision-section">
        {toggleAttachmentDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachmentDisplay}
            onCloseModal={this.onToggleAttachment}
            fileFormats={FILE_FORMATS}
            onSubmit={this.onSuccessUploadOfAttachments}
            canUploadVideo={canUploadVideo}
          />
        ) : null}
        <h2 className="add-decision-heading">Add Decision</h2>
        <div className="add-decision-input-fields">
          <div className="add-decision-content">
            <div className="input-fields d-flex justify-content-between">
              <div className="meeting-name left-input-fields-space">
                <DatePickerField
                  label={"Meeting Date"}
                  isRequiredField={true}
                  className="meeting-date"
                  formData={meetingDate}
                  onChange={this.onMeetingDateChange}
                />
              </div>
              <div className="meeting-name d-flex right-input-fields-space">
                <div className="meeting-start-time">
                  <TimePickerField
                    label={"Meeting Start Time"}
                    className={`${
                      showRequiredError && meetingTimeFrom === ""
                        ? "is-invalid-time"
                        : ""
                    }`}
                    isRequiredField={true}
                    formData={this.state.meetingTimeFrom}
                    value={meetingTimeFrom}
                    name="meeting-start-time"
                    onChange={this.onMeetingTimeChange}
                    showRequiredError={showRequiredError}
                  />
                  {meetingTimeFrom === "" && showRequiredError && (
                    <div class="invalid-feedback">This field is required.</div>
                  )}
                </div>
                <div className="meeting-end-time">
                  <TimePickerField
                    label={"Meeting End Time"}
                    isRequiredField={false}
                    formData={meetingTimeTo}
                    name="meeting-end-time"
                    onChange={this.onMeetingTimeChange}
                  />
                </div>
              </div>
            </div>
            <div className="input-fields d-flex justify-content-between">
              <div className="meeting-name left-input-fields-space">
                <TextField
                  label={"Meeting Name"}
                  className="meeting-name"
                  isRequiredField={true}
                  placeholder={"Enter meeting name"}
                  formData={decisionName}
                  onChange={this.onMeetingInformationChange}
                  name={"meeting-name"}
                  showRequiredError={showRequiredError}
                />
                {decisionName === "" && showRequiredError && (
                  <div class="invalid-feedback">This field is required.</div>
                )}
              </div>
              <div className="meeting-name right-input-fields-space">
                <OptionsField
                  optionsList={
                    projectAddDecisionMeetingTypes !== null
                      ? projectAddDecisionMeetingTypes
                      : ""
                  }
                  keyNameForOption={keyNameForOption}
                  name="meeting-type"
                  label={"Meeting Type"}
                  className="meeting-type"
                  isRequiredField={true}
                  formData={projectMeetingType}
                  onChange={this.onDecisionDropdownSelect}
                  showRequiredError={showRequiredError}
                  placeholderName={"meeting type"}
                  onSelectedField={this.onSelectedField}
                  isTopMarginRequired={true}
                />
                {projectMeetingType === "" && showRequiredError && (
                  <div class="invalid-feedback">This field is required.</div>
                )}
              </div>
            </div>
            <div className="input-fields d-flex justify-content-between">
              <div className="meeting-name left-input-fields-space">
                <TextField
                  label={"Meeting Chaired By"}
                  className="meeting-chairedby"
                  isRequiredField={true}
                  placeholder={"Enter meeting chaired by"}
                  formData={meetingChairedBy}
                  onChange={this.onMeetingInformationChange}
                  name={"meeting-chaired-by"}
                  showRequiredError={showRequiredError}
                />
                {meetingChairedBy === "" && showRequiredError && (
                  <div class="invalid-feedback">This field is required.</div>
                )}
              </div>
              <div className="meeting-name right-input-fields-space">
                <OptionsField
                  name="meeting-venue"
                  keyNameForOption={keyNameForOption}
                  optionsList={pageInfo !== null ? pageInfo.venueList : ""}
                  label={"Meeting Venue"}
                  className="meeting-venue"
                  isRequiredField={true}
                  formData={meetingVenue}
                  onChange={this.onDecisionDropdownSelect}
                  showRequiredError={showRequiredError}
                  placeholderName={"meeting venue"}
                  onSelectedField={this.onSelectedField}
                  isTopMarginRequired={true}
                />
                {meetingVenue === "" && showRequiredError && (
                  <div class="invalid-feedback">This field is required.</div>
                )}
              </div>
            </div>
            <div className="input-fields meeting-mode-buttons d-flex">
              <RadioButtonLayout
                label={"Meeting Mode"}
                className="meeting-mode"
                isRequiredField={true}
                formData={meetingMode}
                name="VIDEO_CONFERENCE"
                onChange={this.onMeetingModeChange}
                toggleLableName="Video conference"
              />

              <RadioButtonLayout
                label={""}
                className="meeting-mode ml-4"
                formData={meetingMode}
                name="IN_PERSON"
                onChange={this.onMeetingModeChange}
                toggleLableName="In-person"
                radioButtonMarginWithoutLabel={true}
              />
            </div>
            <div className="input-fields minutes-of-meeting d-flex ">
              <TextAreaField
                label={"Minutes of the meeting"}
                isRequiredField={true}
                placeholder={"Enter minutes of the meeting"}
                formData={projectMOM}
                onChange={this.onMeetingDescriptionChange}
                showRequiredError={showRequiredError}
              />
            </div>
            <LoaderPage loading={projectAddDecisionStatus === "LOADING"} />
            <Form.Group className="add-attachments-field">
              <div className="attachment-box">
                <DisplayAttachments
                  filesArr={this.state.attachmentPayload}
                  onRemoveFile={this.onRemoveFile}
                  addAttchementRequired={false}
                  classes="attachments"
                />
                {this.state.attachmentPayload.length === 0 && (
                  <div
                    className="add-multiple-files d-flex align-items-center"
                    onClick={this.onToggleAttachment}
                  >
                    <div>
                      <Image src={AddDocument} alt="Plus Icon" />
                    </div>
                    <div className="add-file-text">Add Document</div>
                  </div>
                )}
              </div>
            </Form.Group>
            <div className="text-center">
              <button
                type="button"
                class="btn-orange btn add-decision-button"
                onClick={this.onAddingDecision}
              >
                Submit Decision
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    pageInfo: state.createAgendaReducer.pageInfo,
    projectAddDecisionMeetingTypes:
      state.projectDetailsReducer.projectAddDecisionMeetingTypes
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      removeFileDispatch: removeFileAction,
      loadPageInfo: loadPageInfo,
      getMeetingTypesDetails,
      createProjectDecisionDispatch: createProjectDecisionAction,
      getProjectDecisionDetailsDispatch: getProjectDecisionDetailsAction
    },
    dispatch
  );
}
export default withRouter(
  PermissionHOC(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(AddDecisionSection)
  )
);
